@import "../../../variables.scss";

.profile {
  &__incompleteItems {
    $gap: 22px;
    display: grid;
    gap: $gap;
    $column-width: calc((100% - #{$gap}) / 2);
    grid-template-columns: $column-width $column-width;
    @media (max-width: $size-sm) {
      grid-template-columns: 100%;
    }
    &_complete {
      display: grid;
      $column-width: calc((100% - 2 * #{$gap}) / 3);
      grid-template-columns: $column-width $column-width $column-width;
      gap: $gap;
      @media (max-width: $size-xl) {
        $column-width: calc((100% - #{$gap}) / 2);
        grid-template-columns: $column-width $column-width;
      }
      @media (max-width: $size-sm) {
        grid-template-columns: 100%;
      }
    }
    &_wrapper {
      font-family: Lato;
      font-style: normal;
      font-weight: 300;
      font-size: 28px;
      line-height: 34px;
    }
  }
}
